import type {ProductAnnouncementData} from './../components/ProductAnnouncement/ProductAnnouncement.types'
import ImageBannerBgDarkDesktop from './assets/universe25/banner/bg_dark-desktop.png'
import ImageBannerBgDarkMobile from './assets/universe25/banner/bg_dark-mobile.png'
import ImageBannerBgLightDesktop from './assets/universe25/banner/bg_light-desktop.png'
import ImageBannerBgLightMobile from './assets/universe25/banner/bg_light-mobile.png'
import ImageModalTab1Dark from './assets/universe25/modal/tab1-dark.webp'
import ImageModalTab1Light from './assets/universe25/modal/tab1-light.webp'
import ImageModalTab2Dark from './assets/universe25/modal/tab2-dark.webp'
import ImageModalTab2Light from './assets/universe25/modal/tab2-light.webp'
import ImageModalTab3Dark from './assets/universe25/modal/tab3-dark.jpg'
import ImageModalTab3Light from './assets/universe25/modal/tab3-light.webp'
import ImageModalTab4Dark from './assets/universe25/modal/tab4-dark.webp'
import ImageModalTab4Light from './assets/universe25/modal/tab4-light.webp'
import ImageModalTab5Dark from './assets/universe25/modal/tab5-dark.webp'
import ImageModalTab5Light from './assets/universe25/modal/tab5-light.webp'

const getUTMCampaign = () => {
  return 'universe25post'
}

const getData = (): ProductAnnouncementData => {
  const utmCampaign = getUTMCampaign()

  return {
    banner: {
      title: 'Explore the latest Copilot launches from Universe ’25',
      label: 'See what’s new',
      labelIcon: 'PlusCircleIcon',
      visual: {
        mobile: {
          src: {
            light: ImageBannerBgLightMobile,
            dark: ImageBannerBgDarkMobile,
          },
          alt: 'Illustration of Mona against a soft sky with iridescent clouds, relaxing with a butterfly perched on her nose',
        },
        desktop: {
          src: {
            light: ImageBannerBgLightDesktop,
            dark: ImageBannerBgDarkDesktop,
          },
          alt: 'Illustration of Mona against a soft sky with iridescent clouds, relaxing with a butterfly perched on her nose',
        },
      },
    },
    modal: {
      title: 'Explore what’s new in Copilot',
      cta: {
        label: 'Try with Copilot Pro for free',
        href: `https://github.com/github-copilot/pro?utm_source=web-hpace-copilot-main-cta&utm_medium=web&utm_campaign=${utmCampaign}`,
        isNewWindow: true,
      },
      tabs: [
        {
          title: 'Copilot CLI updates',
          heading: 'Fresh updates for Copilot CLI',
          description: 'Discover custom agents, a new command to push your sessions to cloud agent, and more.',
          visual: {
            type: 'image',
            src: {
              light: ImageModalTab1Light,
              dark: ImageModalTab1Dark,
            },
            alt: 'Image of Copilot CLI terminal prompt',
          },
          cta1: {
            label: 'Install now',
            href: `https://github.com/github/copilot-cli?utm_source=web-hpace-copilot-cli-primary-cta&utm_medium=web&utm_campaign=${utmCampaign}`,
            isNewWindow: true,
          },
          cta2: {
            label: 'Learn more',
            href: `https://gh.io/cli-u25?utm_source=web-hpace-copilot-cli-secondary-cta&utm_medium=web&utm_campaign=${utmCampaign}`,
            isNewWindow: true,
          },
        },
        {
          title: 'Manage agents and their sessions',
          heading: 'All your agents and sessions in one place',
          description:
            'Get a mission-control view of everything your agents are working on, with continuity across GitHub.com, CLI, Mobile, and VS Code.',
          visual: {
            type: 'image',
            src: {
              light: ImageModalTab2Light,
              dark: ImageModalTab2Dark,
            },
            alt: 'Image of a central view displaying various running agent sessions',
          },
          cta1: {
            label: 'Get started',
            href: `https://github.com/copilot/agents?utm_source=web-hpace-agents-primary-cta&utm_medium=web&utm_campaign=${utmCampaign}`,
            isNewWindow: true,
          },
          cta2: {
            label: 'Learn more',
            href: `https://gh.io/mc-u25?utm_source=web-hpace-agents-secondary-cta&utm_medium=web&utm_campaign=${utmCampaign}`,
            isNewWindow: true,
          },
        },
        {
          title: 'Copilot Code review updates',
          heading: 'Copilot code review, enhanced',
          description:
            'Get smarter reviews that combine LLM suggestions with deterministic checks from CodeQL and linters, all powered by new tool calling and a seamless agent handoff.',
          visual: {
            type: 'image',
            src: {
              light: ImageModalTab3Light,
              dark: ImageModalTab3Dark,
            },
            alt: 'Image of Copilot code review running a CodeQL analysis',
            offsetX: '0',
          },
          cta1: {
            label: 'Get started',
            href: `https://docs.github.com/en/copilot/how-tos/use-copilot-agents/request-a-code-review/use-code-review?tool=webui&utm_source=web-hpace-ccr-primary-cta&utm_medium=web&utm_campaign=${utmCampaign}#introduction`,
            isNewWindow: true,
          },
          cta2: {
            label: 'Learn more',
            href: `https://gh.io/ccr-u25?utm_source=web-hpace-ccr-secondary-cta&utm_medium=web&utm_campaign=${utmCampaign}`,
            isNewWindow: true,
          },
        },
        {
          title: 'Copilot integrations',
          heading: 'Your agent, right in your workflow',
          description:
            'Delegate work instantly to Copilot from Slack or Teams, project tools like Azure Boards and Linear, or from your JetBrains IDE.',
          visual: {
            type: 'image',
            src: {
              light: ImageModalTab4Light,
              dark: ImageModalTab4Dark,
            },
            alt: 'Illustration of Copilot next to Microsoft Teams, Slack, and Linear icons',
          },
          cta2: {
            label: 'Connect your tools',
            href: `https://docs.github.com/en/copilot/concepts/tools/about-copilot-integrations?utm_source=web-hpace-integrations-secondary-cta&utm_medium=web&utm_campaign=${utmCampaign}`,
            isNewWindow: true,
          },
        },
        {
          title: 'Plan mode in VS Code',
          heading: 'Plan, approve, then code',
          description:
            "Review and refine your agent's blueprint before it acts through plan mode in GitHub Copilot Chat in VS Code. Don't have Visual Studio Code yet? <a href='https://code.visualstudio.com' target='_blank'>Download now</a>",
          visual: {
            type: 'image',
            src: {
              light: ImageModalTab5Light,
              dark: ImageModalTab5Dark,
            },
            alt: 'Image of zoomed view of ‘plan mode’ in VS Code',
          },
          cta2: {
            label: 'Learn more',
            href: `https://gh.io/pm-u25?utm_source=web-hpace-planmode-secondary-cta&utm_medium=web&utm_campaign=${utmCampaign}`,
            isNewWindow: true,
          },
        },
      ],
      seeAll: {
        label: 'See all announcements',
        href: `https://github.com/events/universe/recap?utm_source=web-hpace-universe-recap&utm_medium=web&utm_campaign=${utmCampaign}`,
        isNewWindow: true,
      },
    },
  }
}

export default getData
